import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import { StoreContext } from "context/store";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "services/api";
import CommentEntry from "./entry";
import CommentInput from "./input";

const Comments = ({ subjectid, notifyFunc = null, closeFunc = null, size = "md" }) => {
  const { store } = useContext(StoreContext);
  const [commentCnts, setCommentCnts] = useState(0);
  const [myUserObj, setMyUserObj] = useState({});
  const [commentObjs, setCommentObjs] = useState([]);

  const reload = (status) => {
    if (status && myUserObj.owner_id && myUserObj.owner_id != "") {
      try {
        api.comment.get(subjectid).then(({ data }) => {
          const topLvlComments = [];
          var cnt = 0;
          for (const comment of data.comments) {
            if (comment.parent_comment_id == "") {
              comment.subComments = [];
              topLvlComments.push(comment);
              ++cnt;
            }
          }
          for (const comment of data.comments) {
            if (comment.parent_comment_id != "") {
              for (const topLvlComment of topLvlComments) {
                if (topLvlComment.id == comment.parent_comment_id) {
                  topLvlComment.subComments.push(comment);
                  ++cnt;
                }
              }
            }
          }
          topLvlComments.sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1));
          for (const comment of topLvlComments) {
            comment.subComments.sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));
          }
          setCommentCnts(cnt);
          setCommentObjs(topLvlComments);
          //console.log('data', myUserObj, data)
          return data;
        });
      } catch (err) {
        toast.error(`get comment failed!`);
        console.log(err);
      }
    }
  };

  useEffect(() => {
    reload(true);
  }, [subjectid, myUserObj]);

  useEffect(() => {
    setMyUserObj({ avatar: store?.metadata?.avatar, username: store?.name, owner_id: store?.id });
  }, [store]);

  return (
    <SuiBox>
      <SuiBox sx={{ py: 0 }}>
        <SuiTypography variant="h6">{commentCnts} Comments</SuiTypography>
        {closeFunc && (
          <IconButton
            aria-label="close"
            onClick={() => {
              closeFunc();
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </SuiBox>
      <CommentInput
        userObj={myUserObj}
        subjectid={subjectid}
        parentReload={reload}
        notifyFunc={notifyFunc}
        size={size}
        allowCancel={false}
      />
      <SuiBox sx={{ overflow: "auto", maxHeight: "500px" }}>
        {commentObjs.map((commentObj) => {
          return (
            <CommentEntry
              key={commentObj.id}
              myUserObj={myUserObj}
              subjectid={subjectid}
              commentObj={commentObj}
              parentReload={reload}
              notifyFunc={notifyFunc}
              size={size}
            />
          );
        })}
      </SuiBox>
    </SuiBox>
  );
};

export default Comments;
